import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "../UserFees.css";
import { publicImageUrl } from "../../../../Config/publicImageUrl";

class BillHeader extends Component {
  render() {
    const { classes, schoolDetails, studentDetails } = this.props;
    return (
      <div>
        <div className={classes.feeRoot}>
          <div style={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
            {schoolDetails.schoolLogo && (
              <img
                src={`${publicImageUrl}/${schoolDetails.schoolLogo}`}
                alt={schoolDetails.schoolName}
                style={{ width: 100, height: 100 }}
              />
            )}
            <div>
              <div>{schoolDetails.schoolName}</div>
              <div>{schoolDetails.address}</div>
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div>
              +977-{schoolDetails.mobileNumber},{schoolDetails.landLineNumber}
            </div>
            <div>{schoolDetails.email}</div>
          </div>
        </div>
        <div
          className={classes.tableStyle}
          style={{ paddingTop: 20, paddingBottom: 20 }}
        >
          <div className={classes.listitemRoot}>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Name:</b>
              <div>
                {studentDetails.firstName} {studentDetails.lastName}
              </div>
            </ListItem>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Class :</b>
              <div>
                <div>{studentDetails.studentClass} </div>
                {studentDetails.faculty && (
                  <div> - {studentDetails.faculty}</div>
                )}
                {studentDetails.group && <div> - {studentDetails.group}</div>}
              </div>
            </ListItem>
          </div>
          <div className={classes.listitemRoot}>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Section :</b>
              <div>{studentDetails.section}</div>
            </ListItem>
            <ListItem>
              <b style={{ flexGrow: 1 }}> Month :</b>
              <div>{this.props.month}</div>
            </ListItem>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(BillHeader);
